<template>
  	<FlexAddNewReseller />
</template>

<script>

// @ is an alias to /src
import FlexAddNewReseller from "@/components/AddNewReseller.vue";

export default {
  name: "FlexAddNewResellers",
  components: {
    FlexAddNewReseller,
  },
};
</script>
